module.exports = __webpack_public_path__ + "images/79ddab691b9ec0db425657edf4a18a12.png";